import gql from 'graphql-tag';
import { factFragment } from '../../../gql';
import { summaryFragment } from '../fragments/summary';
import { footballStatFragment } from '../../../gql/fragments/FootballStats';
import { rugbyLeagueStatFragment } from '../../../gql/fragments/RugbyLeagueStats';
import { rugbyUnionStatFragment } from '../../../gql/fragments/RugbyUnionStats';
export const summarySubscription = gql `
  subscription matchFeed($id: Float!) {
    matchFeed(id: $id) {
      matchSummary {
        ...Summary
      }
      facts {
        ...Fact
      }
    }
  }
  ${factFragment}
  ${summaryFragment}
  ${footballStatFragment}
  ${rugbyLeagueStatFragment}
  ${rugbyUnionStatFragment}
`;
//# sourceMappingURL=summary.js.map